module.exports = __webpack_public_path__ + "static/tron-logo-4e114e6dd997ec90c956b5ece1ff3f3d.png";